if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        this.onClickRefreshList = this.onClickRefreshList.bind(this);

        // Only request pickup data when Shopify reports at least one
        // pickup-enabled availability record for the selected variant.
        if (!this.hasAttribute('available')) {
          this.hidePickupAvailability();
          return;
        }

        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) {
          this.hidePickupAvailability();
          return;
        }

        let rootUrl = this.dataset.rootUrl || '/';
        if (!rootUrl.endsWith('/')) rootUrl += '/';

        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Pickup availability request failed: ${response.status}`);
            }
            return response.text();
          })
          .then((text) => {
            const parsedDocument = new DOMParser().parseFromString(text, 'text/html');
            const sectionInnerHTML = parsedDocument.querySelector('.shopify-section');

            if (!sectionInnerHTML) {
              throw new Error('Pickup availability section was not returned.');
            }

            this.renderPreview(sectionInnerHTML);
          })
          .catch((error) => {
            // Do not expose a technical loading error to customers.
            console.warn('[Pickup availability]', error);
            this.hidePickupAvailability();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.dataset.variantId = variant.id;
          this.fetchAvailability(variant.id);
        } else {
          this.hidePickupAvailability();
        }
      }

      hidePickupAvailability() {
        this.removeAttribute('available');
        this.innerHTML = '';
        this.hidden = true;
      }

      renderPreview(sectionInnerHTML) {
        const preview = sectionInnerHTML.querySelector('pickup-availability-preview');
        const newDrawer = sectionInnerHTML.querySelector('pickup-availability-drawer');

        const currentDrawer = document.querySelector('pickup-availability-drawer');
        if (currentDrawer) currentDrawer.remove();

        // A variant with no pickup-enabled locations should show no storefront block.
        if (!preview) {
          this.hidePickupAvailability();
          return;
        }

        this.hidden = false;
        this.innerHTML = preview.outerHTML;
        this.setAttribute('available', '');

        if (newDrawer) {
          document.body.appendChild(newDrawer);

          // Wokiee's original script assumed this data attribute always existed.
          // It is absent from the product markup, causing .split() to throw and
          // incorrectly display “Couldn't load pickup availability”.
          const colorScheme = (this.dataset.productPageColorScheme || '').trim();
          if (colorScheme) {
            colorScheme.split(/\s+/).forEach((colorClass) => {
              newDrawer.classList.add(colorClass);
            });
          }
        }

        const button = this.querySelector('button');
        if (button && newDrawer) {
          button.addEventListener('click', (event) => {
            newDrawer.show(event.currentTarget);
          });
        }
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        const closeButton = this.querySelector('button');
        if (closeButton) {
          closeButton.addEventListener('click', () => this.close());
        }

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.close();
        });
      }

      handleBodyClick(event) {
        const target = event.target;
        if (
          target !== this &&
          !target.closest('pickup-availability-drawer') &&
          target.id !== 'ShowPickupAvailabilityDrawer'
        ) {
          this.close();
        }
      }

      close() {
        this.classList.remove('animate');
        setTimeout(() => {
          this.classList.remove('active');
          document.body.classList.remove('overflow-hidden');
          document.body.style.paddingRight = '';
        }, 500);

        if (this.focusElement && typeof removeTrapFocus === 'function') {
          removeTrapFocus(this.focusElement);
        }
      }

      show(focusElement) {
        setTimeout(() => {
          this.classList.add('active');
          this.classList.add('animate');
        });

        document.body.style.paddingRight = `${this.getScrollbarWidth()}px`;
        document.body.classList.add('overflow-hidden');
        this.focusElement = focusElement;

        if (typeof trapFocus === 'function') trapFocus(this);
      }

      getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
      }
    }
  );
}
